// extracted by mini-css-extract-plugin
export default {"TranslateBtns":"TranslateBtns_TranslateBtns__u1A70","LangBtn":"TranslateBtns_LangBtn__T319f","CurrentLang":"TranslateBtns_CurrentLang__kouX5"};